import { render, staticRenderFns } from "./UpdateWarrantyConfig.vue?vue&type=template&id=74962780&scoped=true"
import script from "./UpdateWarrantyConfig.vue?vue&type=script&lang=js"
export * from "./UpdateWarrantyConfig.vue?vue&type=script&lang=js"
import style0 from "./UpdateWarrantyConfig.vue?vue&type=style&index=0&id=74962780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74962780",
  null
  
)

export default component.exports